// ----------------------------------------------------------------------

import { cs } from 'date-fns/locale';
import { create } from 'lodash';

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_DASHBOARD = '';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  login: '/login',
};

export const PATH_DASHBOARD = {
  root: path(ROOTS_DASHBOARD, '/dealerportal/account/dealerbook'),
  boatpricelist: path(ROOTS_DASHBOARD, '/dealerportal/dealerbook/boatpricelist'),
  motorpricelist: path(ROOTS_DASHBOARD, '/dealerportal/dealerbook/motorpricelist'),
  optionpricelist: path(ROOTS_DASHBOARD, '/dealerportal/dealerbook/optionpricelist'),
  specsheets: path(ROOTS_DASHBOARD, '/dealerportal/dealerbook/specsheets'),
  coop: path(ROOTS_DASHBOARD, '/dealerportal/dealerbook/coop'),
  importantinfo: path(ROOTS_DASHBOARD, '/dealerportal/dealerbook/importantinfo'),
  attoonshop: path(ROOTS_DASHBOARD, '/dealerportal/dealerbook/attoonshop'),
  contactlist: path(ROOTS_DASHBOARD, '/dealerportal/dealerbook/contactlist'),
  floorplanoverview: path(ROOTS_DASHBOARD, '/dealerportal/dealerbook/floorplanoverview'),
  fusionpackages: path(ROOTS_DASHBOARD, '/dealerportal/dealerbook/fusionpackages'),
  historymission: path(ROOTS_DASHBOARD, '/dealerportal/dealerbook/historymission'),
  internetadvertising: path(ROOTS_DASHBOARD, '/dealerportal/dealerbook/internetadvertising'),
  marketingstrategy: path(ROOTS_DASHBOARD, '/dealerportal/dealerbook/marketingstrategy'),
  instoremarketing: path(ROOTS_DASHBOARD, '/dealerportal/dealerbook/instoremarketing'),
  owneradvisorylist: path(ROOTS_DASHBOARD, '/dealerportal/dealerbook/owneradvisorylist'),
  onlinedealerresources: path(ROOTS_DASHBOARD, '/dealerportal/dealerbook/onlinedealerresources'),
  paintcodes: path(ROOTS_DASHBOARD, '/dealerportal/dealerbook/paintcodes'),
  metaljacket: path(ROOTS_DASHBOARD, '/dealerportal/dealerbook/metaljacket'),

  account: {
    dealerinvoices: path(ROOTS_DASHBOARD, '/dealerportal/account/dealerinvoices'),
    viewinvoice: path(ROOTS_DASHBOARD, '/dealerportal/account/viewinvoice'),
    boatorders: path(ROOTS_DASHBOARD, '/dealerportal/account/boatorders'),
    viewstatement: path(ROOTS_DASHBOARD, '/dealerportal/account/viewstatement'),
  },
  dealermeeting: {
    root: path(ROOTS_DASHBOARD, '/dealerportal/dealermeeting'),
    openhousepresentation: path(
      ROOTS_DASHBOARD,
      '/dealerportal/dealermeeting/openhousepresentation'
    ),
    openhouseboats: path(ROOTS_DASHBOARD, '/dealerportal/dealermeeting/openhouseboats'),
    dealermeetingimages: path(ROOTS_DASHBOARD, '/dealerportal/dealermeeting/dealermeetingimages'),
  },
  marketing: {
    root: path(ROOTS_DASHBOARD, '/dealerportal/marketing'),
    excalibur2026: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2026/excalibur'),
    excaliburltd2026: path(
      ROOTS_DASHBOARD,
      '/dealerportal/marketing/modelgallery/2026/excaliburltd'
    ),
    catalina2026: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2026/catalina'),
    lsz2026: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2026/lsz'),
    venture852026: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2026/venture85'),
    venture2026: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2026/venture'),
    avalongeofish2026: path(
      ROOTS_DASHBOARD,
      '/dealerportal/marketing/modelgallery/2026/avalon-geofish'
    ),
    grandtahoe2026: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2026/grandtahoe'),
    grandtahoeltd2026: path(
      ROOTS_DASHBOARD,
      '/dealerportal/marketing/modelgallery/2026/grandtahoeltd'
    ),
    cascade2026: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2026/cascade'),
    ltz2026: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2026/ltz'),
    sport852026: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2026/sport85'),
    sport2026: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2026/sport'),
    tahoegeofish2026: path(
      ROOTS_DASHBOARD,
      '/dealerportal/marketing/modelgallery/2026/tahoe-geofish'
    ),
    aura2026: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2026/aura'),
    excalibur2027: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2027/excalibur'),
    excaliburltd2027: path(
      ROOTS_DASHBOARD,
      '/dealerportal/marketing/modelgallery/2027/excaliburltd'
    ),
    catalina2027: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2027/catalina'),
    lsz2027: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2027/lsz'),
    venture852027: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2027/venture85w'),
    venture2027: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2027/venture75w8w'),
    venturepromo2027: path(
      ROOTS_DASHBOARD,
      '/dealerportal/marketing/modelgallery/2027/venturepromo85w'
    ),
    avalongeofish2027: path(
      ROOTS_DASHBOARD,
      '/dealerportal/marketing/modelgallery/2027/avalon-geofish'
    ),
    grandtahoe2027: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2027/grandtahoe'),
    grandtahoeltd2027: path(
      ROOTS_DASHBOARD,
      '/dealerportal/marketing/modelgallery/2027/grandtahoeltd'
    ),
    cascade2027: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2027/cascade'),
    ltz2027: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2027/ltz'),
    sport852027: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2027/sport85w'),
    sport2027: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2027/sport75w8w'),
    patriot: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2027/patriot'),
    sportpromo2027: path(
      ROOTS_DASHBOARD,
      '/dealerportal/marketing/modelgallery/2027/sportpromo85w'
    ),
    tahoegeofish2027: path(
      ROOTS_DASHBOARD,
      '/dealerportal/marketing/modelgallery/2027/tahoe-geofish'
    ),
    aura2027: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2027/aura'),
    excalibur: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2025/excalibur'),
    excaliburltd: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2025/excaliburltd'),
    catalina: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2025/catalina'),
    lsz: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2025/lsz'),
    venture85: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2025/venture85'),
    venture: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2025/venture'),
    avalongeofish: path(
      ROOTS_DASHBOARD,
      '/dealerportal/marketing/modelgallery/2025/avalon-geofish'
    ),
    aura: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2025/aura'),
    grandtahoe: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2024/grandtahoe'),
    grandtahoeltd: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2025/grandtahoeltd'),
    cascade: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2025/cascade'),
    ltz: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2025/ltz'),
    sport85: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2025/sport85'),
    sport: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2025/sport'),
    tahoegeofish: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2025/tahoe-geofish'),
    avalonbrochures: path(ROOTS_DASHBOARD, '/dealerportal/marketing/avalonbrochures'),
    tahoebrochures: path(ROOTS_DASHBOARD, '/dealerportal/marketing/tahoebrochures'),
    marketingtools: path(ROOTS_DASHBOARD, '/dealerportal/marketing/marketingtools'),
    avalonvideos: path(ROOTS_DASHBOARD, '/dealerportal/marketing/avalonvideos'),
    tahoevideos: path(ROOTS_DASHBOARD, '/dealerportal/marketing/tahoevideos'),
    socialmedia: path(ROOTS_DASHBOARD, '/dealerportal/marketing/socialmedia'),
    uploadsocialmedia: path(ROOTS_DASHBOARD, '/dealerportal/marketing/upload-social-media'),

    // Archive 1 year previous //
    waketoonarchive1: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2024/waketoon'),
    excaliburarchive1: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2024/excalibur'),
    excaliburltdarchive1: path(
      ROOTS_DASHBOARD,
      '/dealerportal/marketing/modelgallery/2024/excaliburltd'
    ),
    catalinaarchive1: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2024/catalina'),
    lszarchive1: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2024/lsz'),
    venture85archive1: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2024/venture85'),
    venturearchive1: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2024/venture'),
    vlsarchive1: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2024/vls'),
    vtxarchive1: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2024/vtx'),
    grandtahoearchive1: path(
      ROOTS_DASHBOARD,
      '/dealerportal/marketing/modelgallery/2024/grandtahoe'
    ),
    grandtahoeltdarchive1: path(
      ROOTS_DASHBOARD,
      '/dealerportal/marketing/modelgallery/2024/grandtahoeltd'
    ),
    cascadearchive1: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2024/cascade'),
    ltzarchive1: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2024/ltz'),
    sport85archive1: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2024/sport85'),
    sportarchive1: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2024/sport'),
    sltarchive1: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2024/slt'),

    // Archive 2 years previous //
    waketoonarchive: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2023/waketoon'),
    excaliburarchive: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2023/excalibur'),
    excaliburltdarchive: path(
      ROOTS_DASHBOARD,
      '/dealerportal/marketing/modelgallery/2023/excaliburltd'
    ),
    catalinaarchive: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2023/catalina'),
    lszarchive: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2023/lsz'),
    venture85archive: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2023/venture85'),
    venturearchive: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2023/venture'),
    vlsarchive: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2023/vls'),
    vtxarchive: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2023/vtx'),
    grandtahoearchive: path(
      ROOTS_DASHBOARD,
      '/dealerportal/marketing/modelgallery/2023/grandtahoe'
    ),
    grandtahoeltdarchive: path(
      ROOTS_DASHBOARD,
      '/dealerportal/marketing/modelgallery/2023/grandtahoeltd'
    ),
    cascadearchive: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2023/cascade'),
    ltzarchive: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2023/ltz'),
    sport85archive: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2023/sport85'),
    sportarchive: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2023/sport'),
    sltarchive: path(ROOTS_DASHBOARD, '/dealerportal/marketing/modelgallery/2023/slt'),
  },
  warranty: {
    root: path(ROOTS_DASHBOARD, '/dealerportal/warranty'),
    warrantyregistration: path(ROOTS_DASHBOARD, '/dealerportal/warranty/warrantyregistration'),
    warrantyregistrationform: path(
      ROOTS_DASHBOARD,
      '/dealerportal/warranty/warrantyregistrationform'
    ),
    warrantyclaimform: path(ROOTS_DASHBOARD, '/dealerportal/warranty/warrantyclaimform'),
    warrantytransfer: path(ROOTS_DASHBOARD, '/dealerportal/warranty/warrantytransfer'),
    writtenwarranty: path(ROOTS_DASHBOARD, '/dealerportal/warranty/writtenwarranty'),
    warrantyprocedure: path(ROOTS_DASHBOARD, '/dealerportal/warranty/warrantyprocedure'),
    paperwarrantyclaimform: path(ROOTS_DASHBOARD, '/dealerportal/warranty/paperwarrantyclaimform'),
    viewregistration: path(ROOTS_DASHBOARD, '/dealerportal/warranty/viewregistration'),
    warrantytracker: path(ROOTS_DASHBOARD, '/dealerportal/warranty/warrantyclaimtracker'),
  },
  training: {
    root: path(ROOTS_DASHBOARD, '/dealerportal/training'),
    trainingday: path(ROOTS_DASHBOARD, '/dealerportal/training/trainingday'),
    damagedengineprocess: path(ROOTS_DASHBOARD, '/dealerportal/training/damagedengineprocess'),
    avalonproducttraining: path(ROOTS_DASHBOARD, '/dealerportal/training/avalonproducttraining'),
    tahoeproducttraining: path(ROOTS_DASHBOARD, '/dealerportal/training/tahoeproducttraining'),
    avalonmodelcomparison: path(ROOTS_DASHBOARD, '/dealerportal/training/avalonmodelcomparison'),
    tahoemodelcomparison: path(ROOTS_DASHBOARD, '/dealerportal/training/tahoemodelcomparison'),
    avalonwaketoontraining: path(ROOTS_DASHBOARD, '/dealerportal/training/avalonwaketoontraining'),
    tahoewaketoontraining: path(ROOTS_DASHBOARD, '/dealerportal/training/tahoewaketoontraining'),
  },
  paperforms: {
    root: path(ROOTS_DASHBOARD, '/dealerportal/paperforms'),
    coopclaimform: path(ROOTS_DASHBOARD, '/dealerportal/paperforms/coopclaimform'),
    newadvisorchecklist: path(ROOTS_DASHBOARD, '/dealerportal/paperforms/newadvisorchecklist'),
    quickorderform: path(ROOTS_DASHBOARD, '/dealerportal/paperforms/quickorderform'),
    returngoodsform: path(ROOTS_DASHBOARD, '/dealerportal/paperforms/returngoodsform'),
    msorequest: path(ROOTS_DASHBOARD, '/dealerportal/paperforms/msorequest'),
  },
  inventory: {
    root: path(ROOTS_DASHBOARD, '/dealerportal/inventory'),
    boatinventory: path(ROOTS_DASHBOARD, '/dealerportal/inventory/boatinventory'),
    stockboat: path(ROOTS_DASHBOARD, '/dealerportal/inventory/stockboat'),
  },
  customerservice: {
    root: path(ROOTS_DASHBOARD, '/dealerportal/customerservice'),
    regionalmap: path(ROOTS_DASHBOARD, '/dealerportal/customerservice/regionalmap'),
    servicepartspricing: path(ROOTS_DASHBOARD, '/dealerportal/customerservice/servicepartspricing'),
    serviceorderform: path(ROOTS_DASHBOARD, '/dealerportal/customerservice/serviceorderform'),
    serviceorder: path(ROOTS_DASHBOARD, '/dealerportal/customerservice/serviceorder'),
    partorderlist: path(ROOTS_DASHBOARD, '/dealerportal/customerservice/partorderlist'),
    partorder: path(ROOTS_DASHBOARD, '/dealerportal/customerservice/partorder'),
    rmahome: path(ROOTS_DASHBOARD, '/dealerportal/customerservice/rmahome'),
    partlookup: path(ROOTS_DASHBOARD, '/dealerportal/customerservice/partlookup'),
    partlookupboatentry: path(ROOTS_DASHBOARD, '/dealerportal/customerservice/partlookupboatentry'),
    inspectionpicturelookup: path(
      ROOTS_DASHBOARD,
      '/dealerportal/customerservice/inspectionpicturelookup'
    ),
    serviceorderstatus: path(ROOTS_DASHBOARD, '/dealerportal/customerservice/serviceorderstatus'),
  },
  technicalinformation: {
    root: path(ROOTS_DASHBOARD, '/dealerportal/technicalinformation'),
    view: path(ROOTS_DASHBOARD, '/dealerportal/technicalinformation/view'),
  },
  manuals: {
    root: path(ROOTS_DASHBOARD, '/dealerportal/manuals'),
    view: path(ROOTS_DASHBOARD, '/dealerportal/manuals/view'),
  },
  maintenanceportal: {
    root: path(ROOTS_DASHBOARD, '/dealerportal/maintenanceportal'),
    maintenance: path(ROOTS_DASHBOARD, '/dealerportal/maintenanceportal/maintenance'),
    createbulletin: path(ROOTS_DASHBOARD, '/dealerportal/createbulletin'),
    dashboard: path(ROOTS_DASHBOARD, '/maintenanceportal/dashboard'),
    technicalinformation: path(ROOTS_DASHBOARD, '/maintenanceportal/technicalinformation'),
    cswarrantyclaimtracker: path(ROOTS_DASHBOARD, '/maintenanceportal/cswarrantyclaimtracker'),
  },
  survey: {
    root: path(ROOTS_DASHBOARD, '/survey'),
    scorecard: path(ROOTS_DASHBOARD, '/survey/scorecard'),
  },
};
